export default "__VITE_ASSET__b21de2bd__"